<template>
    <!--@formatter:off-->
    <li v-if="isShowOption">
        <strong class="tit">{{$t('EnrolmentQuestionProgramCountEditor_count')}}<em class="required">*</em></strong>
        <div class="cont">
            <span class="item">
                <em>{{$t('EnrolmentQuestionProgramCountEditor_regular')}}</em>
                <TextInput
                    type="text"
                    :id="`limit-${questionIndex}-${programIndex}`"
                    :title="$t('EnrolmentQuestionProgramCountEditor_inputRegular')"
                    input-style="display: unset"
                    wrapper-class=""
                    input-class=""
                    :only-number="true"
                    :maxlength="3"
                    v-model="limit"
                />
                <span class="txt">{{$t('common_peopleCount')}}</span>
            </span>
            <span class="item">
                <em>{{$t('EnrolmentQuestionProgramCountEditor_reserved')}}</em>
                <TextInput
                    type="text"
                    :title="$t('EnrolmentQuestionProgramCountEditor_inputReserved')"
                    input-style="display: unset"
                    wrapper-class=""
                    input-class=""
                    :only-number="true"
                    :maxlength="3"
                    v-model="reservedLimit"
                />
                <span class="txt">{{$t('common_peopleCount')}}</span>
            </span>
            <span v-show="isShowPreDrawing" class="item">
                <em>{{$t('EnrolmentQuestionProgramCountEditor_preDrawing')}}</em>
                <span
                    class="txt lottery"
                    :class="{count: drawPriors.length}"
                >{{$t('EnrolmentQuestionProgramCountEditor_preDrawingCount', {number: drawPriors.length})}}</span>
            </span>
            <button
                v-show="isShowPreDrawing"
                type="button"
                class="btn_input sm"
                @click="openDrawPriorsPopup"
                v-ga-helper:click="gaOpenDrawPriorsPopup"
            >{{drawPriorsButtonText}}</button>
        </div>
    </li>
    <!--@formatter:on-->
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {ENROLMENT_TYPE} from '@common/consts/survey';
import TextInput from '@iamteacherpc/components/common/TextInput';
import {requestDrawPriors} from '@iamteacherpc/utils/iframe';
import {mapActions} from 'vuex';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList';
import {SET_PROGRAM_DRAW_PRIORS} from '@common/store/modules/enrolment/editor';

export default {
    name: "EnrolmentQuestionProgramCountEditor",
    components: {TextInput},

    props: {
        questionIndex: {
            type: Number,
            required: true,
        },

        programIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        ...mapFields('enrolment', ['form.enrolmentType']),
        ...createComputed('limit'),
        ...createComputed('reservedLimit'),
        ...createComputed('drawPriors'),

        isShowOption() {
            return this.enrolmentType !== ENROLMENT_TYPE.RANDOM;
        },

        isShowPreDrawing() {
            return this.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
        },

        storePath() {
            return `form.questions.${this.questionIndex}.programs.${this.programIndex}`;
        },

        program() {
            return this.$store.getters['enrolment/getField'](this.storePath);
        },

        drawPriorsButtonText() {
            if (this.drawPriors.length) {
                return this.$t('EnrolmentQuestionProgramCountEditor_preDrawingEdit');
            } else {
                return this.$t('EnrolmentQuestionProgramCountEditor_preDrawingAssign');
            }
        },
    },

    methods: {
        ...mapActions('enrolment', {
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
            setProgramDrawPriors: SET_PROGRAM_DRAW_PRIORS,
        }),

        async openDrawPriorsPopup() {
            try {
                this.stopListChange();

                const {isCancel, drawPriors} = await requestDrawPriors({
                    drawPriors: this.drawPriors,
                });

                if (isCancel) {
                    return;
                }

                this.setProgramDrawPriors({
                    program: this.program,
                    drawPriors,
                });
            } finally {
                this.listChange();
            }
        },

        gaOpenDrawPriorsPopup() {
            return {
              view_category: '수강신청프로그램',
              view_area: this.drawPriors.length ? '선추첨대상자수정클릭' : '선추첨대상자선택클릭',
              view_label: '',
            }
        },
    },
}

function createComputed(key) {
    return {
        [key]: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.storePath}.${key}`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.storePath}.${key}`,
                    value: newValue,
                });
            },
        },
    }
}
</script>

<style scoped>

</style>